// extracted by mini-css-extract-plugin
export var externalLink = "_at-0";
export var internalLinkLabel = "_at-1";